import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  clearError: () => void;
}

const initialState: Pick<AuthState, 'isAuthenticated' | 'loading' | 'error'> = {
  isAuthenticated: false,
  loading: true,
  error: null,
};

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      ...initialState,
      login: async (username: string, password: string) => {
        try {
          set({ loading: true, error: null });
          
          // Simüle edilmiş API çağrısı
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          if (username === 'admin' && password === '123') {
            set({ isAuthenticated: true, loading: false });
            return true;
          } else {
            set({ error: 'Geçersiz kullanıcı adı veya şifre', loading: false });
            return false;
          }
        } catch (error) {
          set({ 
            error: error instanceof Error ? error.message : 'Bir hata oluştu', 
            loading: false 
          });
          return false;
        }
      },
      logout: () => {
        set({ isAuthenticated: false, error: null });
      },
      clearError: () => {
        set({ error: null });
      }
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        // Sayfa yüklendiğinde loading'i false yap
        if (state) {
          state.loading = false;
        }
      },
    }
  )
);